import { Directive } from '@angular/core';

interface SettingItem {
    icon: string;
    titleKey: string;
    descriptionKey: string;
    link: string;
}

// @dynamic
@Directive()
export abstract class AEmptyBasePage {
    pageTitleKey: string;
    pageDescriptionKey: string;
    settingItems: SettingItem[] = [];
}
